import React from 'react'
import styles from './FirmwareUpdateModal.module.css'
// import {
//     // ArrowBigDownDash,
//     // ArrowUpFromLine,
//     // BrushCleaning,
//     // CircleCheck,
//     // CloudAlert,
//     // Hourglass,
//     // Pickaxe,
//     // Search,
//     // Sparkles,
// } from 'lucide-react'
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
    CloudDownload,
    CloudUpload,
    DeleteSweep,
    CheckCircle,
    ErrorOutlineRounded,
    HourglassEmpty,
    Build,
    Search,
    CloudDone,
} from '@material-ui/icons'
const FirmwareAssetsUpdateModal = ({
    isOpen,
    stage,
    message,
    percent,
    onClose,
}) => {
    // console.log('FirmwareAssetsUpdateModal render:', { isOpen, stage, message, percent })
    if (!isOpen) return null

    // Theme Gradients
    const themeGradient = 'linear-gradient(to right, #fda84e, #f97d62)' // Your Orange Theme
    const successGradient = 'linear-gradient(to right, #4caf50, #8bc34a)' // Soft Green
    const errorGradient = 'linear-gradient(to right, #ff6b6b, #ff8e8e)' // Soft Red

    const getStageIcon = (currentStage) => {
        const iconStyle = {
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))', // Softer shadow for icon
            color: 'white',
        }

        switch (currentStage) {
            case 'checking':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <Search
                            size={20}
                            color="white"
                            strokeWidth={2.5}
                            style={iconStyle}
                        />
                    </div>
                )
            case 'downloading':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <CloudDownload
                            size={20}
                            color="white"
                            fill="white"
                            style={iconStyle}
                        />
                    </div>
                )
            case 'extracting':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <Build
                            size={20}
                            color="white"
                            strokeWidth={2.5}
                            style={iconStyle}
                        />
                    </div>
                )
            case 'cleaning':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <DeleteSweep
                            size={20}
                            color="white"
                            strokeWidth={2.5}
                            style={iconStyle}
                        />
                    </div>
                )
            case 'uploading':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <CloudUpload
                            size={20}
                            color="white"
                            strokeWidth={2.5}
                            style={iconStyle}
                        />
                    </div>
                )
            case 'finalizing':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <CloudDone
                            size={20}
                            color="white"
                            strokeWidth={2.5}
                            style={iconStyle}
                        />
                    </div>
                )
            case 'complete':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: successGradient }}
                    >
                        <CheckCircle
                            size={20}
                            color="white"
                            fill="white"
                            style={iconStyle}
                        />
                    </div>
                )
            case 'error':
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: errorGradient }}
                    >
                        <ErrorOutlineRounded
                            size={20}
                            color="white"
                            fill="white"
                            style={iconStyle}
                        />
                    </div>
                )
            default:
                return (
                    <div
                        className={styles.iconGradient}
                        style={{ background: themeGradient }}
                    >
                        <HourglassEmpty
                            size={20}
                            color="white"
                            strokeWidth={2.5}
                            style={iconStyle}
                        />
                    </div>
                )
        }
    }

    const stages = [
        { id: 'checking', label: 'Checking' },
        { id: 'downloading', label: 'Downloading' },
        { id: 'extracting', label: 'Extracting' },
        { id: 'cleaning', label: 'Cleaning' },
        { id: 'uploading', label: 'Uploading' },
        { id: 'finalizing', label: 'Finalizing' },
    ]

    const currentStageIndex = stages.findIndex((s) => s.id === stage)

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2>Firmware Update</h2>
                    <div className={styles.iconWrapper}>
                        {getStageIcon(stage)}
                    </div>
                </div>

                <div className={styles.content}>
                    {/* Stage Steps */}
                    <div className={styles.stageIndicator}>
                        {stages.map((s, index) => (
                            <div
                                key={s.id}
                                className={`${styles.stageItem} ${
                                    index < currentStageIndex
                                        ? styles.completed
                                        : index === currentStageIndex
                                          ? styles.active
                                          : ''
                                }`}
                            >
                                <div className={styles.stageDot}></div>
                                <span className={styles.stageLabel}>
                                    {s.label}
                                </span>
                            </div>
                        ))}
                    </div>

                    {/* Active Message & Progress */}
                    {stage !== 'complete' && stage !== 'error' && (
                        <div className={styles.messageContainer}>
                            <p className={styles.message}>{message}</p>

                            {/* Spinner Dots */}
                            <div className={styles.spinner}>
                                <div className={styles.spinnerDot}></div>
                                <div className={styles.spinnerDot}></div>
                                <div className={styles.spinnerDot}></div>
                            </div>

                            {percent !== undefined && percent !== null && (
                                <div className={styles.progressBar}>
                                    <div
                                        className={styles.progressFill}
                                        style={{ width: `${percent}%` }}
                                    ></div>
                                    <span className={styles.progressText}>
                                        {percent}%
                                    </span>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Complete State */}
                    {stage === 'complete' && (
                        <div className={styles.successMessage}>
                            <p>Update completed successfully!</p>
                            <button
                                className={styles.closeButton}
                                onClick={onClose}
                            >
                                Done
                            </button>
                        </div>
                    )}

                    {/* Error State */}
                    {stage === 'error' && (
                        <div className={styles.errorMessage}>
                            <p>{message}</p>
                            <button
                                className={styles.closeButton}
                                onClick={onClose}
                            >
                                Close
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default FirmwareAssetsUpdateModal
